import React from 'react';
import { Box, Button, Typography, Divider } from '@mui/material';
import { Email as EmailIcon, OpenInNew as OpenInNewIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import SectionHeader from '../../../../../components/common/SectionHeader';

export function EmailSection({ task, divider = true }) {
  const { t } = useTranslation(['tasks']);

  const mailtoHref = `mailto:${task.email_recipient || ''}?subject=${encodeURIComponent(task.email_subject || '')}&body=${encodeURIComponent(task.email_body || '')}`;

  return (
    <Box>
      {divider && <Divider sx={{ mb: 3 }} />}
      <SectionHeader
        icon={EmailIcon}
        title={t('tasks:details.email_action', { defaultValue: 'Email Action' })}
        actions={
          <Button
            variant="contained"
            color="info"
            startIcon={<EmailIcon />}
            endIcon={<OpenInNewIcon />}
            href={mailtoHref}
            component="a"
            size="small"
          >
            {t('tasks:actions.open_email', { defaultValue: 'Open in email client' })}
          </Button>
        }
      />
      <Box sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 2, overflow: 'hidden' }}>
        {task.email_recipient && (
          <Box sx={{
            display: 'flex', alignItems: 'center', gap: 2,
            px: 2, py: 1.25,
            borderBottom: '1px solid', borderColor: 'divider',
          }}>
            <Typography variant="caption" color="text.secondary" sx={{ minWidth: 56, fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.5 }}>
              {t('tasks:labels.email_recipient', { defaultValue: 'To' })}
            </Typography>
            <Typography variant="body2">{task.email_recipient}</Typography>
          </Box>
        )}
        {task.email_subject && (
          <Box sx={{
            display: 'flex', alignItems: 'center', gap: 2,
            px: 2, py: 1.25,
            borderBottom: task.email_body ? '1px solid' : 'none', borderColor: 'divider',
          }}>
            <Typography variant="caption" color="text.secondary" sx={{ minWidth: 56, fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.5 }}>
              {t('tasks:labels.email_subject', { defaultValue: 'Subject' })}
            </Typography>
            <Typography variant="body2" fontWeight={500}>{task.email_subject}</Typography>
          </Box>
        )}
        {task.email_body && (
          <Box sx={{ px: 2, py: 2 }}>
            <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap', lineHeight: 1.7 }}>
              {task.email_body}
            </Typography>
          </Box>
        )}
      </Box>
    </Box>
  );
}

export default EmailSection;
